import React, { FunctionComponent } from 'react'
import { useLoaderData, useMatch, useParams } from '@tanstack/react-router'
import { backgroundColor } from '../../theme'
import VehicleLocationHistoryList from '../VehicleLocationHistoryList/VehicleLocationHistoryList'
import Map from '../Map/Map'
import { Tabs } from 'antd'
import type { TabsProps } from 'antd'
import VehicleDetails from './VehicleDetails/VehicleDetails'
import VehicleLocationDetails from './VehicleLocationDetails/VehicleLocationDetails'

const Vehicle: FunctionComponent<any> = () => {
  const { id } = useParams({ strict: false })
  const match = useMatch({ strict: false })
  const { vehicleLocations } = useLoaderData({ from: match.routeId ?? '/' })

  const vehicleLocation = vehicleLocations[0]

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Vehicle',
      children: <VehicleDetails />
    },
    {
      key: '2',
      label: 'Location',
      children: <VehicleLocationDetails />
    },
    {
      key: '3',
      label: 'Location History',
      children: <VehicleLocationHistoryList vehicleId={id} />
    }
  ]

  return (
    <div style={{ display: 'flex', height: '100%', backgroundColor }}>
      <div style={{ flex: 1, height: '100vh', overflow: 'auto' }}>
        <Tabs defaultActiveKey="1" items={items} />
      </div>
      <div style={{ flex: 3 }}>
        <Map
          defaultCenter={{
            lat: vehicleLocation?.latitude,
            lng: vehicleLocation?.longitude
          }}
        />
      </div>
    </div>
  )
}

export default Vehicle
